import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { SubscriptionManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/subscriptions")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <SubscriptionManagement />
    </RouteGuard>
  ),
});
